import { Skeleton } from '@parrot-software/design-system';
import { cn } from '@parrot-software/utils';

type InventoryLoadingSkeletonProps = {
  className?: string;
};

/**
 * Placeholder with the inventory module's layout (section sidebar plus content), shown while the
 * module decides what to render or while the remote loads, so the page does not jump.
 * @param {InventoryLoadingSkeletonProps} props - Component properties
 */
export const InventoryLoadingSkeleton = ({ className }: InventoryLoadingSkeletonProps) => (
  <div
    aria-busy="true"
    className={cn('flex h-full w-full gap-6 p-6 font-sans', className)}
    data-testid="inventory-loading-skeleton"
  >
    <div className="hidden w-56 shrink-0 flex-col gap-3 md:flex">
      <Skeleton className="h-6 w-32" />
      <Skeleton className="h-8 w-full" />
      <Skeleton className="h-8 w-full" />
      <Skeleton className="h-8 w-full" />
      <Skeleton className="h-8 w-full" />
    </div>
    <div className="flex min-w-0 grow flex-col gap-4">
      <Skeleton className="h-8 w-64" />
      <Skeleton className="h-10 w-full" />
      <Skeleton className="h-64 w-full" />
    </div>
  </div>
);
